import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BusinessRulesModel } from './api-surveymodel.service';
import { UserStoreService } from './user-store.service';

export interface ApiPostSurveyBusinessRulesResponse {
  applied: string[];
  failed: {name: string, type: string, reason: string}[];
  isFullSuccess: boolean;
}

@Injectable({ providedIn: 'root' })
export class ApiSurveyBusinessRulesService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/survey/businessrules';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  updateSurveyBusinessRules(organizationId: string, surveyId: string, rules: BusinessRulesModel[]): Observable<ApiPostSurveyBusinessRulesResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const params = new HttpParams()
      .set('organization', organizationId)
      .set('survey', surveyId);

    const request = rules;

    return this.http.post<ApiPostSurveyBusinessRulesResponse>(`${this.apiBaseUrl}${this.apiPath}`, request, {params});
  }
}